import scroll_animation from './component/scroll_animation/scroll_animation';
import anime from './component/anime/anime';
import smooth_scroll from './component/smooth_scroll/smooth_scroll'

export default () => {
    scroll_animation();
    anime();

    smooth_scroll.addSmoothEvent({
        triggers: 'a[href^="#"]'
    });
}